import { ChevronDown } from 'lucide-react';
import { cn } from '../../utils/cn';
import './scroll-hint-motion.css';

export interface ScrollHintProps {
    /** There is more below, and the reader has not shown they know it moves. */
    show: boolean;
    /**
     * Lifts the hint off the bottom edge, for a step that pins its own action
     * there. Without it the hint sits behind that bar, which is opaque.
     */
    className?: string;
    /**
     * Measured distance of a pinned bar above the pane's bottom edge, in
     * pixels. Wins over `className`'s offset, so the hint clears the bar
     * whatever its height.
     */
    bottomOffset?: number | null;
}

/** The hint's own gap from whatever it sits above. */
const HINT_GAP_PX = 8;

/**
 * Marks a scroll the reader cannot otherwise see.
 *
 * Both surfaces hide their scrollbar, so a step taller than the pane looks
 * complete: the reader has no signal that the thing they came for is below the
 * fold. Shared by the card and the sheet, which each own their own scroll
 * container but should say the same thing about it.
 */
export const ScrollHint = ({
    show,
    className,
    bottomOffset,
}: ScrollHintProps) => (
    <div
        aria-hidden
        className={cn(
            // Never takes the pointer: it marks the scroll, it is not a
            // control, and the step's own actions sit under it.
            'pointer-events-none absolute inset-x-0 bottom-2 flex justify-center transition-opacity duration-300',
            show ? 'opacity-100' : 'opacity-0',
            bottomOffset == null && className,
        )}
        style={
            bottomOffset == null
                ? undefined
                : { bottom: bottomOffset + HINT_GAP_PX }
        }
    >
        <span className="rocco-scroll-hint-nudge flex size-7 items-center justify-center rounded-full bg-white/85 shadow-[0_1px_4px_rgba(0,0,0,0.12)] backdrop-blur-sm">
            <ChevronDown className="size-4 text-[#828282]" />
        </span>
    </div>
);
